module.exports = __webpack_public_path__ + "static/media/cnx-logo-long.0ea7fbdf.svg";